export default __webpack_public_path__ + "static/assets/e9acedd92586667001afd40a4ee75ca0.svg";